import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount } from 'vue'
  import useBreakpoint from '@/composables/useBreakpoint'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AutoSlider',
  props: {
    items: null,
    itemsPerSlide: null,
    autoPlayInterval: null,
    showDots: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    items: any[]
    itemsPerSlide?: number
    autoPlayInterval?: number
    showDots?: boolean
  };

  

  const { isMobileDevice } = useBreakpoint()

  const currentSlide = ref(0)
  const intervalRef = ref<number | null>(null)

  const nextSlide = () => {
    const itemsPerSlide = props.itemsPerSlide || (isMobileDevice.value ? 1 : 2)
    currentSlide.value = (currentSlide.value + 1) % Math.ceil(props.items.length / itemsPerSlide)
  }

  const navigateToSlide = (index: number) => {
    currentSlide.value = index
    resetInterval()
  }

  const resetInterval = () => {
    if (intervalRef.value) {
      clearInterval(intervalRef.value)
    }
    intervalRef.value = window.setInterval(nextSlide, props.autoPlayInterval || 5000)
  }

  onMounted(() => {
    intervalRef.value = window.setInterval(nextSlide, props.autoPlayInterval || 5000)
  })

  onBeforeUnmount(() => {
    if (intervalRef.value) {
      clearInterval(intervalRef.value)
    }
  })

return { __sfc: true,props, isMobileDevice, currentSlide, intervalRef, nextSlide, navigateToSlide, resetInterval, ref, onMounted, onBeforeUnmount, useBreakpoint }
}

})